import styled, { css } from 'styled-components/';
import { getSizeInRem, getSizeInPx } from '../methods/common.js';

const flexStyle = css `
    margin: ${({ margin }) => getSizeInRem(margin)};
    padding: ${({ padding }) => getSizeInRem(padding)};
    display: ${({ display }) => (display ? display : "flex")};
    flex-direction: ${({ flexDirection }) => flexDirection !== null && flexDirection !== void 0 ? flexDirection : "row"};
    justify-content: ${({ justifyContent }) => justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start"};
    align-items: ${({ alignItems }) => alignItems};
    align-self: ${({ alignSelf }) => alignSelf};
    gap: ${({ gap }) => getSizeInPx(gap)};
    row-gap: ${({ rowGap }) => getSizeInPx(rowGap)};
    flex-wrap: ${({ flexWrap }) => flexWrap !== null && flexWrap !== void 0 ? flexWrap : "nowrap"};
    flex: ${({ flex }) => flex};
`;
const Flex = styled.div `
    ${flexStyle}
`;
const VerticalFlex = styled(Flex) `
    ${flexStyle}
    flex-direction: column;
`;

export { Flex, VerticalFlex, Flex as default };
//# sourceMappingURL=Flex.js.map
